export default __webpack_public_path__ + "static/media/slider5.5afc182c.jpg";